/**
 * Yarn Colors Data
 * Common yarn colors for crochet projects - organized by color family
 */

export const YARN_COLORS = [
    // Neutrals & Whites
    { name: 'White', hex: '#FFFFFF' },
    { name: 'Cream', hex: '#FFFDD0' },
    { name: 'Beige', hex: '#F5F5DC' },
    { name: 'Tan', hex: '#D2B48C' },
    { name: 'Light Gray', hex: '#D3D3D3' },
    { name: 'Gray', hex: '#808080' },
    { name: 'Brown', hex: '#8B4513' },
    { name: 'Black', hex: '#000000' },
    
    // Pinks
    { name: 'Light Pink', hex: '#FFB6C1' },
    { name: 'Pink', hex: '#FFC0CB' },
    { name: 'Hot Pink', hex: '#FF69B4' },
    { name: 'Rose', hex: '#FF007F' },
    
    // Reds
    { name: 'Red', hex: '#FF0000' },
    { name: 'Burgundy', hex: '#800020' },
    
    // Oranges
    { name: 'Peach', hex: '#FFE5B4' },
    { name: 'Coral', hex: '#FF7F50' },
    { name: 'Orange', hex: '#FFA500' },
    
    // Yellows
    { name: 'Yellow', hex: '#FFFF00' },
    { name: 'Gold', hex: '#FFD700' },
    { name: 'Mustard', hex: '#FFDB58' },
    
    // Greens
    { name: 'Light Green', hex: '#90EE90' },
    { name: 'Mint', hex: '#98FF98' },
    { name: 'Sage', hex: '#87AE73' },
    { name: 'Green', hex: '#008000' },
    { name: 'Forest Green', hex: '#228B22' },
    { name: 'Dark Green', hex: '#006400' },
    { name: 'Olive', hex: '#808000' },
    
    // Blues
    { name: 'Light Blue', hex: '#ADD8E6' },
    { name: 'Sky Blue', hex: '#87CEEB' },
    { name: 'Turquoise', hex: '#40E0D0' },
    { name: 'Teal', hex: '#008080' },
    { name: 'Blue', hex: '#0000FF' },
    { name: 'Navy', hex: '#000080' },
    
    // Purples
    { name: 'Lavender', hex: '#E6E6FA' },
    { name: 'Purple', hex: '#800080' },
    { name: 'Violet', hex: '#8F00FF' },
    { name: 'Plum', hex: '#8E4585' }
];

export const HOOK_SIZES = [
    '2.0mm (B/1)',
    '2.25mm (B/1)',
    '2.5mm (C/2)',
    '2.75mm (C/2)',
    '3.0mm (D/3)',
    '3.25mm (D/3)',
    '3.5mm (E/4)',
    '3.75mm (F/5)',
    '4.0mm (G/6)',
    '4.5mm (7)',
    '5.0mm (H/8)',
    '5.5mm (I/9)',
    '6.0mm (J/10)',
    '6.5mm (K/10.5)',
    '8.0mm (L/11)',
    '9.0mm (M/13)',
    '10.0mm (N/15)',
    '12.0mm (P/16)',
    '15.0mm (Q)',
    '16.0mm (Q)',
    '19.0mm (S)'
];

export default YARN_COLORS;
